var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 60,
    viewBox: "0 0 69 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9186 29.8124V24.4687C13.9186 19.7221 16.087 15.17 19.9467 11.8137C23.8065 8.45734 29.0415 6.57178 34.5 6.57178C39.9585 6.57178 45.1935 8.45734 49.0532 11.8137C52.913 15.17 55.0814 19.7221 55.0814 24.4687V29.8124",
    stroke: "black",
    strokeWidth: 2.8125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0022 29.8125H18.0694V42.3563H13.0022C12.1444 42.3563 11.3217 42.0599 10.7151 41.5325C10.1086 41.005 9.76782 40.2897 9.76782 39.5438V32.625C9.76782 31.8791 10.1086 31.1637 10.7151 30.6363C11.3217 30.1088 12.1444 29.8125 13.0022 29.8125Z",
    stroke: "black",
    strokeWidth: 2.8125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9978 42.3562H50.9306V29.8125H55.9978C56.8556 29.8125 57.6783 30.1088 58.2849 30.6362C58.8914 31.1637 59.2322 31.879 59.2322 32.625V39.5437C59.2322 40.2896 58.8914 41.005 58.2849 41.5324C57.6783 42.0599 56.8556 42.3562 55.9978 42.3562Z",
    stroke: "black",
    strokeWidth: 2.8125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7391 42.7124V47.3999C55.7391 48.3945 55.2847 49.3483 54.476 50.0516C53.6672 50.7548 52.5703 51.1499 51.4266 51.1499H39.4163",
    stroke: "white",
    strokeWidth: 2.8125,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2492 48.675H32.8289C31.638 48.675 30.6726 49.5145 30.6726 50.55V51.5532C30.6726 52.5887 31.638 53.4282 32.8289 53.4282H37.2492C38.44 53.4282 39.4054 52.5887 39.4054 51.5532V50.55C39.4054 49.5145 38.44 48.675 37.2492 48.675Z",
    stroke: "black",
    strokeWidth: 2.8125,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/CustomerSupport.c59d46bca66958eefe9193b9b0a07872.svg";
export { ForwardRef as ReactComponent };